import { baseApi } from "./base.api";

export const labReportApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchLabReports: build.query({
      query: (params) => ({ url: "/lab-reports/fetch", method: "GET", params }),
      providesTags: ["LabReport"],
    }),
    fetchTrashedLabReports: build.query({
      query: (params) => ({ url: "/lab-reports/fetch/trashed", method: "GET", params }),
      providesTags: ["LabReport"],
    }),
    fetchLabReportAll: build.query({
      query: () => ({ url: "/lab-reports/fetch/all", method: "GET" }),
      providesTags: ["LabReport"],
    }),
    fetchPhysiciansAll: build.query({
      query: (unit_id) => ({ url: `/lab-reports/all/physicians/${unit_id}`, method: "GET" }),
      providesTags: ["LabReport"],
    }),
    fetchLabReportById: build.query({
      query: (id) => ({ url: `/lab-reports/fetch/${id}`, method: "GET" }),
      providesTags: ["LabReport"],
    }),
    fetchLabReportByTracking: build.mutation({
      query: (body) => ({ url: `/lab-reports/fetch/by/tracking`, method: "POST", body }),
      providesTags: ["LabReport"],
    }),
    createLabReport: build.mutation({
      query: (body) => ({ url: "/lab-reports/create", method: "POST", body }),
      invalidatesTags: ["LabReport"],
    }),
    updateLabReport: build.mutation({
      query: ({ id, body }) => ({ url: `/lab-reports/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["LabReport"],
    }),
    restoreLabReport: build.mutation({
      query: (id) => ({ url: `/lab-reports/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["LabReport"],
    }),
    bulkRestoreLabReports: build.mutation({
      query: (body) => ({ url: "/lab-reports/bulk-restore", method: "POST", body }),
      invalidatesTags: ["LabReport"],
    }),
    deleteLabReport: build.mutation({
      query: (id) => ({ url: `/lab-reports/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["LabReport"],
    }),
    bulkDeleteLabReports: build.mutation({
      query: (body) => ({ url: "/lab-reports/bulk-delete", method: "POST", body }),
      invalidatesTags: ["LabReport"],
    }),
    destroyLabReport: build.mutation({
      query: (id) => ({ url: `/lab-reports/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["LabReport"],
    }),
    bulkDestroyLabReports: build.mutation({
      query: (body) => ({ url: "/lab-reports/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["LabReport"],
    }),
  }),
});

export const {
  useFetchLabReportAllQuery,
  useFetchTrashedLabReportsQuery,
  useFetchLabReportByIdQuery,
  useCreateLabReportMutation,
  useUpdateLabReportMutation,
  useRestoreLabReportMutation,
  useBulkRestoreLabReportsMutation,
  useDeleteLabReportMutation,
  useFetchLabReportsQuery,
  useBulkDeleteLabReportsMutation,
  useFetchPhysiciansAllQuery,
  useDestroyLabReportMutation,
  useFetchLabReportByTrackingMutation,
  useBulkDestroyLabReportsMutation,
} = labReportApi;
